import { StdResponse, request } from "@/global/config/request";
import { Calibration, CalibrationItem } from "@/global/interface/calibration";
import { VideoMonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";

/**
  * 根据监测对象id获取对应的标定对象
  * 
  * @param projectId 项目id
  */
export function addCalibration(monitorParameterId: number, params?: {}): Promise<StdResponse<Calibration>> {
    return request.post(`/monitor-params/${monitorParameterId}/calibration`, {
        params: {
            ...params,
        }
    })
}




/**
  * 根据监测对象id获取对应的标定对象
  * 
  * @param projectId 项目id
  */
export function getCalibration(monitorParameterId: number, params?: {}): Promise<StdResponse<Calibration>> {
    return request.get(`/monitor-params/${monitorParameterId}/calibration`, {
        params: {
            ...params,
        }
    })
}

/**
  * 根据标定中的单个对象idCalibration的id获取图像信息
  * 
  * @param projectId 项目id
  */
export function getCalibrationItemImage(calibrationItemId: string, params?: {}): Promise<StdResponse<CalibrationItem>> {
    return request.get(`/calibration-items/${calibrationItemId}/image`, {
        params: {
            ...params,
        }
    })
}


/**
  * 根据标定中的单个对象的uuid删除单个标定对象
  * 
  * @param projectId 项目id
  */
export function deleteCalibrationItem(calibrationItemId: string, params?: {}): Promise<StdResponse<CalibrationItem>> {
    return request.delete(`/calibration-items/${calibrationItemId}/image`, {
        params: {
            ...params,
        }
    })
}

export function getParamPictureList(paramId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/params/${paramId}/pictures`, {
        params: {
            ...params,
        },
    })
}

export function getParamPictureDetail(pictureId: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/param-pictures/${pictureId}`, {
        params: {
            ...params,
        },
    })
}

export function getRectifyPictureListByParamId(paramId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/params/${paramId}/rectify-pictures`, {
        params: {
            ...params,
        },
    })
}


/**
  * 获得监测对象列表，含根监测参数和直接参数
  * 
  * @param projectId 项目id
  */
export function getVideoMonitorObjectByProjectId(projectId: number, params?: {}): Promise<StdResponse<VideoMonitorParameter[]>> {
    return request.get(`/projects/${projectId}/video-monitor-params`, {
        params: {
            ...params,
        }
    })
}

/**
 * 编辑视频的监测参数
 *
 * @param paramId 监测对象id
 * @param data    监测对象数据
 */
export function updateVideoMonitorParam(paramId: number, data: VideoMonitorParameter): Promise<StdResponse<VideoMonitorParameter>> {
    return request.put(`/params/${paramId}/video`, data);
}

/**
 * 标定拍照
 * @param paramId 
 * @returns 
 */
export function takeCalibrationPhoto(paramId: number): Promise<StdResponse<VideoMonitorParameter>> {
    return request.post(`/video-monitor-params/${paramId}/take-photo`);
}

/**
 * 标定重新设置经纬度
 * @param paramId 
 * @returns 
 */
export function calibrationFixPosition(paramId: number): Promise<StdResponse<VideoMonitorParameter>> {
    return request.post(`/video-monitor-params/${paramId}/fix-position`);
}
/**
 * 生成标定结果
 * @param paramId 
 * @returns 
 */
export function generateCalibrationResult(paramId: number): Promise<StdResponse<VideoMonitorParameter>> {
    return request.post(`/video-monitor-params/${paramId}/generate-caibration-result`);
}

export function clearExtParameter(paramId: number): Promise<StdResponse<VideoMonitorParameter>> {
    return request.post(`/video-monitor-params/${paramId}/clear-ext-parameter`);
}
